import React from "react";
import MatrixOSInfoShell from "./MatrixOSInfoShell";
import { LegalSection } from "./legalContentStyles";

const linkedinUrl = "https://www.linkedin.com/company/112805381/";

export default function Contact() {
  const linkStyle = { color: "#67e8f9", fontWeight: 800, textDecoration: "none" };

  return (
    <MatrixOSInfoShell
      eyebrow="Contact MatrixOS"
      title="Contact the MatrixOS team."
      subtitle="For product questions, partnerships, rollout planning, billing, privacy, general enquiries and Discovery conversations."
    >
      <LegalSection title="General enquiries">
        Email <a href="mailto:admin@matrixos.co.za" style={linkStyle}>admin@matrixos.co.za</a> or call <a href="tel:+27751677058" style={linkStyle}>+27 75 167 7058</a>.
      </LegalSection>

      <LegalSection title="Follow MatrixOS">
        Follow MatrixOS on <a href={linkedinUrl} target="_blank" rel="noreferrer" style={linkStyle}>LinkedIn ↗</a> for product progress, operational thinking and company updates.
      </LegalSection>

      <LegalSection title="Book a Discovery">
        For a guided conversation about your operation, current systems, pain points and rollout fit, contact the MatrixOS team using the details on this page.
      </LegalSection>

      <LegalSection title="Location">
        MatrixOS is based in Cape Town, South Africa and is built for multi-site operators.
      </LegalSection>
    </MatrixOSInfoShell>
  );
}
